import { put, takeEvery, call } from 'typed-redux-saga'
import { getUserInterviewsSuccess, getUserInterviewsFailure } from './actions'
import { getUserInterviews as getUserInterviewsApi } from '../api/controllers/user-interviews.controller'

function* getUserInterviewsSaga() {
  try {
    const data = yield* call(getUserInterviewsApi)
    yield put(
      getUserInterviewsSuccess({
        regular_interviews: data.regular_interviews || [],
        ava_interviews: data.ava_interviews || [],
      })
    )
  } catch (err) {
    const errorMessage = (err as any).response?.data?.error || 'Failed to load interviews'
    yield put(getUserInterviewsFailure({ error: errorMessage }))
  }
}

export function* watchGetUserInterviews() {
  yield takeEvery('USER_INTERVIEWS/GET_USER_INTERVIEWS', getUserInterviewsSaga)
}

